import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

/**
 * Subtle live "viewing now" pill, bottom-left on desktop.
 * Number drifts every few seconds within a small range to feel live.
 */
export const VisitorCounter = () => {
  const [n, setN] = useState(() => 7 + Math.floor(Math.random() * 9));

  useEffect(() => {
    const id = setInterval(() => {
      setN((prev) => {
        const delta = Math.random() < 0.5 ? -1 : 1;
        const next = Math.max(5, Math.min(22, prev + delta));
        return next;
      });
    }, 4200);
    return () => clearInterval(id);
  }, []);

  return (
    <motion.div
      data-testid="visitor-counter"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.4, duration: 0.6 }}
      className="hidden lg:flex fixed bottom-6 left-6 z-30 items-center gap-2 glass rounded-full pl-2 pr-4 py-1.5 border border-white/5"
    >
      <span className="relative flex w-2.5 h-2.5">
        <span className="absolute inset-0 rounded-full bg-emerald-400 opacity-70 animate-ping" />
        <span className="relative w-2.5 h-2.5 rounded-full bg-emerald-400" />
      </span>
      <span className="text-xs text-[#B0B0B0]">
        <span className="text-white font-medium">{n}</span> viewing this page
      </span>
    </motion.div>
  );
};
